import { Button } from 'antd';
import styled from 'styled-components';

import RangePickerCustom from '../../atoms/LegacyRangePickerCustom';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 1047px) {
    .order-by-col {
      width: 65%;
    }

    .order-by-select {
      width: 100%;
    }
  }
`;

export const RangerPicker = styled(RangePickerCustom)`
  height: 40px;
  width: 250px;
  margin-right: 16px;

  @media (max-width: 1047px) {
    width: 100%;
  }
`;

export const FilterButton = styled(Button)`
  height: 40px;
  width: 100px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }

  @media (max-width: 1047px) {
    width: 27%;
  }
`;

export const ButtonDropdown = styled(Button)`
  margin-right: 16px;
  height: 40px;

  &.ant-btn-default {
    &:hover,
    &:active,
    &:focus {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};

    &:hover {
      background-color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.hoveredDiv};
    }
  }
`;
